import { useHistory, useLocation } from 'react-router-dom';
import MenuBar from 'components/MenuBar';
import {
  getActiveWorkOrderTab,
  getWorkOrderTabs,
  WorkOrderAccess,
} from './workOrderNavigation';

// Secondary tab bar of the Work Orders section, styled like the Worktime
// sub-bar. Hidden when the user may use a single tab only.
const WorkOrderTabs = ({ access }: { access: WorkOrderAccess }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const tabs = getWorkOrderTabs(access);
  const active = tabs.findIndex(
    ({ key }) => key === getActiveWorkOrderTab(pathname),
  );

  if (tabs.length < 2 || active < 0) {
    return null;
  }

  return (
    <MenuBar
      value={active}
      setValue={(index) => {
        const tab = tabs[Number(index)];
        if (tab && tab.key !== pathname) {
          history.push(tab.key);
        }
      }}
      options={tabs.map(({ label }, index) => ({ label, key: index }))}
    />
  );
};

export default WorkOrderTabs;
